export const previewStartReq = [
  {
    id: 1,
    text: 'Show the total number of clicks from Facebook for the last month',
  },
  { id: 2, text: 'Compare impressions from Facebook and Google Ads' },
  {
    id: 3,
    text: 'Show Google Analytics conversion data grouped by device type',
  },
  // COMMENTATO: Il pulsante Black Friday richiede troppo tempo per funzionare correttamente
  // e quando gli utenti ci cliccano genera risultati errati
  // {
  //   id: 4,
  //   text: 'Analyze last year\'s Black Friday',
  //   isMultiQuery: true,
  //   queries: [
  //     'dimmi quanto ho fatturato l\'anno scorso al black friday',
  //     'show me total spend from Facebook and Google Ads for black friday last year',
  //     'calcolami il roi',
  //   ],
  // },
];
